<template>
    <Toast ref="toastRef" />
    <MainLoader :visible="true" size="80px" color="blue" v-if="!hotels?.value || !hotels?.value?.content?.name" />
    <div class="container pb-10" v-else>
      <button @click="backToMainView" class="my-5 mx-auto lsp-btn px-3 py-2 rounded text-sm font-medium">
        <span> &lt; back</span>
      </button>
      <div class="pb-10 flex justify-between">
        <div>
          <h1 class="text-2xl mb-2 font-bold title">
            {{ hotels.value?.content.name }}
          </h1>
          <div>
            <span v-for="i in hotels.rating" :key="i" class="text-yellow-400">
              <i class="fas fa-star"></i>
            </span>
  
            <p class="price" v-if="hotels.value?.content?.affiliate_price">
              Price:
              <span class="font-semibold">
                AUD ${{ roundPrice(hotels.value?.content?.price) }}
              </span>
            </p>
            <span class="text-gray-600 flex" v-else>
              {{ hotels.value?.content?.ratings?.property?.rating }}
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                class="w-5 h-5 text-yellow-600">
                <path fill-rule="evenodd"
                  d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z"
                  clip-rule="evenodd"></path>
              </svg>
              {{ `- ${getFullAdress}` }}
            </span>
          </div>
        </div>
      </div>
      <div class="flex flex-wrap gap-4 mb-4">
        <div class="w-full md:flex-[0_0_calc(50%_-_0.5rem)] md:max-w-[calc(50%_-_0.5rem)]">
          <!-- ✅ Use Custom Slider Component -->
          <ImageSlider :images="hotels.value?.images" :imageWiseSlide="true" />
        </div>
  
        <!-- Map Section -->
        <div class="w-full md:flex-[0_0_calc(50%_-_0.5rem)] md:max-w-[calc(50%_-_0.5rem)]">
          <div class="w-full h-[400px] overflow-hidden rounded-xl mb-4">
            <iframe :src="getMapUrl" class="border-0 w-full h-full"></iframe>
          </div>
          <div class="content-address">
            <p>Address</p>
            <span class="text-gray-600">{{
              hotels.value?.listing.third_party_type === "affiliate"
                ? getFullAdressForAffliate
                : getFullAdress
            }}
            </span>
            <div class="mt-3">
              <span class="text-gray-600" v-if="hotels.value?.listing.stra_number">STRA: #{{
                hotels.value?.listing.stra_number }}</span>
            </div>
            <div class="mt-3" v-if="
              hotels.value?.listing.third_party_type === 'affiliate' &&
              hotels.value?.listing.third_party_snippet
            ">
              <button @click="
                redirectToParterWebsite(
                  hotels.value?.listing.third_party_snippet
                )
                " class="lsp-btn w-full px-4 py-2">
                Book On Partner Website
              </button>
            </div>
          </div>
        </div>
      </div>
  
      <div class="mt-8 bg-stone-100 p-5 rounded-md flex flex-wrap gap-2 justify-end sm:!justify-between"
        v-if="hotels.value?.listing.third_party_type !== 'affiliate'">
        <input type="text" name="searchHotelName" placeholder="Search another hotel by name"
          class="w-full sm:!w-1/2 px-4 py-2 border border-stone-300 rounded-lg focus:ring focus:ring-blue-300 focus:outline-none"
          v-model="searchHotelNameDetail">
  
        <!-- Search Button at the Bottom -->
        <button type="submit" class="float-right lsp-btn px-4 py-2 rounded text-sm font-medium"
          @click="searchByHotelName">
          Search
        </button>
      </div>
  
      <!-- REQUESTTOBOOK Section -->
      <div class="mt-4 bg-stone-100 p-5 rounded-md" v-if="hotels.value?.listing">
        <div class="flex justify-between flex-wrap w-full gap-3 mb-6" v-if="hotels.value?.listing">
          <div class="flex items-center gap-2">
            <i class="fa fa-user text-gray-700"></i>
            <span class="text-sm text-gray-600">Max Guest Adults: <strong>{{ hotels.value?.listing?.r2b_property_details?.max_adults || '-' }}</strong></span>
          </div>

          <div class="flex items-center gap-2">
            <i class="fa fa-child text-gray-700"></i>
            <span class="text-sm text-gray-600">Max Guest Children: <strong>{{ hotels.value?.listing?.r2b_property_details?.max_children || '-' }}</strong></span>
          </div>

          <div class="flex items-center gap-2">
            <img :src="`${API_URL}/images/amenities/infants.png`" alt="Infant" class="w-4 h-4">
            <span class="text-sm text-gray-600">Max Guest Infants: <strong>{{ hotels.value?.listing?.r2b_property_details?.max_infants || '-' }}</strong></span>
          </div>

          <div class="flex items-center gap-2">
            <i class="fa fa-bed text-gray-700"></i>
            <span class="text-sm text-gray-600">Bedrooms: <strong>{{ hotels.value?.listing?.r2b_property_details?.no_of_bedrooms || '-' }}</strong></span>
          </div>

          <div class="flex items-center gap-2">
            <i class="fa fa-bath text-gray-700"></i>
            <span class="text-sm text-gray-600">Bathrooms: <strong>{{ hotels.value?.listing?.r2b_property_details?.no_of_bathrooms || '-' }}</strong></span>
          </div>

          <div class="flex items-center gap-2">
            <i class="fa fa-clock-o text-gray-700"></i>
            <span class="text-sm text-gray-600">Min. Nights: <strong>{{ hotels.value?.content?.min_nights || '-' }}</strong></span>
          </div>
        </div>

        <hr class="my-6">

        <div class="mt-4 flex gap-4 flex-wrap w-full">

          <!-- Calendars Section - Side by Side -->
          <div class="flex gap-4 flex-wrap">
            <!-- Check-in Calendar -->
            <div class="flex flex-col">
              <label for="r2bCheckInDate" class="text-sm font-medium text-gray-600 mb-1">
                Check-in
              </label>
              <input
                type="text"
                id="r2bCheckInDate"
                class="w-full px-4 h-8 py-2 border border-gray-300 rounded-lg focus:ring focus:ring-blue-300 focus:outline-none"
                aria-label="Check-in date"
              />
            </div>

            <!-- Check-out Calendar -->
            <div class="flex flex-col">
              <label for="r2bCheckOutDate" class="text-sm font-medium text-gray-600 mb-1">
                Check-out
              </label>
              <input
                type="text"
                id="r2bCheckOutDate"
                class="w-full px-4 h-8 py-2 border border-gray-300 rounded-lg focus:ring focus:ring-blue-300 focus:outline-none"
                aria-label="Check-out date"
              />
            </div>
          </div>

          <!-- Guests Details Section -->
          <div class="flex flex-col gap-2" style="width: 256px;">
            <label class="text-sm font-medium text-gray-600">Guests Details</label>
            
            <!-- Adults Input -->
            <div class="flex flex-col">
              <label class="text-sm font-medium text-gray-600 mb-1">Adults</label>
              <input type="number" 
                class="px-3 py-1 border border-gray-300 rounded-lg w-full focus:ring focus:ring-blue-300 focus:outline-none" 
                v-model.number="r2bAdults" 
                min="1"
                :max="r2bMaxAdults ?? null" 
                @keydown="handleGuestKeydown('adults', $event)"
                @mousedown="handleGuestMouseDown('adults', $event)"
                @wheel="handleGuestWheel('adults', $event)"
                placeholder="Adults"
                style="height: 32px;">
            </div>

            <!-- Children Input -->
            <div class="flex flex-col">
              <label class="text-sm font-medium text-gray-600 mb-1">Children</label>
              <input type="number" 
                class="px-3 py-1 border border-gray-300 rounded-lg w-full focus:ring focus:ring-blue-300 focus:outline-none" 
                v-model.number="r2bChildren"
                min="0" 
                :max="r2bMaxChildren ?? null" 
                @keydown="handleGuestKeydown('children', $event)"
                @mousedown="handleGuestMouseDown('children', $event)"
                @wheel="handleGuestWheel('children', $event)"
                placeholder="Children"
                style="height: 32px;">
            </div>

            <!-- Infants Input -->
            <div class="flex flex-col">
              <label class="text-sm font-medium text-gray-600 mb-1">Infants</label>
              <input type="number" 
                class="px-3 py-1 border border-gray-300 rounded-lg w-full focus:ring focus:ring-blue-300 focus:outline-none" 
                v-model.number="r2bInfants" 
                min="0"
                :max="r2bMaxInfants ?? null" 
                @keydown="handleGuestKeydown('infants', $event)"
                @mousedown="handleGuestMouseDown('infants', $event)"
                @wheel="handleGuestWheel('infants', $event)"
                placeholder="Infants"
                style="height: 32px;">
            </div>

            <!-- Check Availability and Reset Buttons -->
            <div class="flex gap-2 mt-2">
              <button type="button" 
                class="px-4 py-2 lsp-btn rounded-lg flex-1"
                @click="checkAvailability"
                :disabled="isCheckingAvailability"
                style="white-space: nowrap;">
                <span v-if="isCheckingAvailability">
                  <i class="fas fa-spinner fa-spin"></i> Checking...
                </span>
                <span v-else>Check Availability</span>
              </button>

              <button type="button" 
                class="px-4 py-2 lsp-btn grey rounded-lg"
                @click="resetR2BForm"
                :disabled="isCheckingAvailability"
                style="white-space: nowrap;">
                Reset
              </button>
            </div>
          </div>

          <!-- Booking Summary Section -->
          <div class="flex flex-col" style="margin-left: 32px; min-width: 200px;">
            <h3 class="text-lg font-medium text-gray-600 mb-4">Booking Summary</h3>

            <div class="flex flex-col mb-2">
              <label class="text-sm font-medium text-gray-600">
                Check-in: {{ formattedCheckin || '-' }}
              </label>
            </div>

            <div class="flex flex-col mb-2">
              <label class="text-sm font-medium text-gray-600">
                Check-out: {{ formattedCheckout || '-' }}
              </label>
            </div>

            <div class="flex flex-col mb-4">
              <label class="text-sm font-medium text-gray-600">
                Price: {{ bookingPrice }}&nbsp;<small class="text-xs text-gray-500">(Inc. GST)</small>
              </label>
            </div>

          <div v-if="showBookingButton">
            <button type="button" 
              class="w-full lsp-btn px-4 py-2 rounded-lg"
              @click="bookR2BProperty">
              Book
            </button>
          </div>
          </div>
        </div>
      </div>

      <!-- RateHawk Section (existing) -->
      <div class="mt-4 bg-stone-100 p-5 rounded-md" v-if="hotels.value?.listing?.third_party_type === 'Ratehawk'">
        <div class="flex flex-col gap-4 mb-4">
          <div class="md:flex flex-wrap md:!flex-nowrap gap-4 ">
            <div class="md:mb-0 mb-3">
              <label class="text-sm font-medium text-gray-600 mb-1">Check-in</label>
              <input type="date" v-model="checkinDate"
                class="w-full lg:w-[150px] px-4 py-2 border rounded-lg focus:ring focus:ring-blue-300 focus:outline-none"
                @change="updateCheckoutMinDate" />
            </div>
  
            <div class="">
              <label class="text-sm font-medium text-gray-600 mb-1">Check-out</label>
              <input type="date" v-model="checkoutDate"
                class="w-full lg:w-[150px] px-4 py-2 border rounded-lg focus:ring focus:ring-blue-300 focus:outline-none"
                :min="minCheckoutDate" />
            </div>
  
            <div class="w-full ml-0 md:!ml-10 flex flex-col gap-4">
              <div v-for="(room, index) in rooms" :key="index" class="md:flex items-center flex-wrap gap-4">
                <h4 class="mt-5 text-sm font-semibold text-stone-900">Room {{ index + 1 }}</h4>
  
                <div class="mb-3">
                  <label class="block text-sm font-medium text-gray-600 mb-1">Adults</label>
                  <input type="number" v-model.number="room.adults" min="1" max="6"
                    class="px-3 py-2 border rounded-lg w-full lg:w-[60px]" @input="validateAdults(room)" />
                </div>
  
                <div class="mb-3">
                  <label class="block text-sm font-medium text-gray-600 mb-1">Children<span
                      class="text-[11px]">(s)</span></label>
                  <input type="number" v-model.number="room.children" min="0" max="4"
                    class="px-3 py-2 border rounded-lg w-full lg:[60px]" @input="validateChildren(room)" />
                </div>
  
                <div v-if="room.children > 0" class="md:flex flex-wrap gap-6">
                  <div v-for="(child, childIndex) in room.children" :key="childIndex" class="mb-3">
                    <label class="block text-sm font-medium text-gray-600 mb-1">Child {{ childIndex + 1 }} Age</label>
                    <input type="number" v-model.number="room.ages[childIndex]" min="0" max="17"
                      class="px-3 py-2 border rounded-lg w-full lg:w-[60px]"
                      @input="validateChildAge(room, childIndex)" />
                  </div>
                </div>
  
                <button v-if="index > 0" @click="removeRoom(index)"
                  class="cursor-pointer rounded-full bg-red-600 py-[4px] px-[10px] text-white">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="h-5 w-5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
  
              <div class="flex justify-end gap-4 mt-4">
                <button href="javascript:void(0)" @click="addRoom"
                  class="hidden bg-gray-800 px-3 py-2 text-white rounded-lg hover:bg-gray-950">
                  <i class="fa fa-plus text-white"></i> Add Another Room
                </button>
  
                <button type="submit" class="lsp-btn px-4 py-2 rounded text-sm font-medium" @click="getPropertyData">
                  Search
                </button>
  
                <button class="lsp-btn px-4 py-2 rounded text-sm font-medium grey" @click="getResetData">
                  Reset
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <div class="my-6" v-if="hotels.value?.content.listing_description">
        <h3 class="mb-2 text-base font-semibold leading-6 text-stone-700">
          Property Description
        </h3>
        <hr />
        <p class="my-6" v-html="hotels.value?.content?.listing_description"></p>
        <hr />
      </div>
  
      <!-- R2B Rooms Section - Only show for REQUESTTOBOOK -->
      <div v-if="hotels.value?.listing?.r2b_property_details?.room_details?.length > 0">
        <h3 class="mt-4 mb-3 text-gray-800 text-lg">
          Available Rooms for {{ formatR2BDate(r2bCheckin) }} to {{ formatR2BDate(r2bCheckout) }} 
          for {{ r2bAdults }} adults, {{ r2bChildren }} children and {{ r2bInfants }} infants
        </h3>
        
        <div 
          v-for="(room, index) in hotels.value?.listing?.r2b_property_details?.room_details" 
          :key="index"
          class="mb-5 items-start gap-4 border border-gray-300 rounded-lg"
        >
          <!-- Header Section -->
          <div class="flex">
            <!-- Details -->
            <div class="flex-1 max-w-[calc(100%-150px)]">
              <div class="px-2 py-2">
                <h2 class="text-xl font-bold">{{ room.room_name }}</h2>
              </div>
            </div>
          </div>
          
          <!-- Table Section -->
          <div class="overflow-x-auto xl:overflow-x-visible w-full">
            <table class="w-full text-sm">
              <thead class="bg-gray-800 text-white">
                <tr>
                  <th class="py-1 px-4 border-r border-gray-300">No of Beds</th>
                  <th class="py-1 px-4 border-r border-gray-300">Bed Type</th>
                  <th class="py-1 px-4 border-r border-gray-300">Sleeps</th>
                  <th class="py-1 px-4 border-r border-gray-900">Ensuite Bathroom</th>
                </tr>
              </thead>
              <tbody>
                <tr class="text-center">
                  <td class="p-3 border-r border-t rounded-bl-lg border-gray-300">
                    {{ room.no_of_beds }}
                  </td>
                  <td class="p-3 border-r border-t rounded-bl-lg border-gray-300">
                    {{ room.bed_type }}
                  </td>
                  <td class="p-3 border-r border-t rounded-bl-lg border-gray-300">
                    {{ room.sleeps }}
                  </td>
                  <td class="p-3 border-r border-t rounded-bl-lg border-gray-300">
                    {{ (room.ensuite === 'on' || room.ensuite === true || room.ensuite === 1) ? 'Yes' : 'No' }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      
      <!-- Show "No rooms found!" only if thirdPartyType is REQUESTTOBOOK and no rooms, but not affiliate -->
      <div 
        v-else-if="hotels.value?.listing?.third_party_type !== 'affiliate'" 
        class="my-6"
      >
        <p class="text-bold py-5 text-center">
          <strong>No rooms found!</strong>
        </p>
      </div>
  
      <!-- Room Section -->
      <div class="mb-4 bg-stone-100 shadow-sm sm:rounded-lg" v-if="
        isArray(hotels?.value?.content?.descriptions)
          ? hotels?.value?.content?.descriptions?.length
          : hotels?.value?.content?.descriptions
      ">
        <div class="border-b border-stone-300 p-4 sm:px-6">
          <h3 class="text-base font-semibold leading-6 text-stone-700">
            Description
          </h3>
        </div>
        <div>
          <dl class="sm:divide-y sm:divide-stone-200 p-4">
            <div v-for="(value, key) in hotels?.value?.content?.descriptions" :key="key"
              class="py-2 sm:grid sm:grid-cols-3 sm:gap-4  sm:py-5">
              <dt class="text-sm font-medium text-gray-500">{{ key }}</dt>
              <dd class="mt-1 text-sm text-stone-900 sm:col-span-2 sm:mt-0">
                {{ value }}
              </dd>
            </div>
          </dl>
        </div>
      </div>
      <div class="bg-stone-100 p-4 rounded-lg mb-4" v-if="hotels?.value?.amenities?.length">
        <h2 class="text-base font-semibold leading-6 text-stone-700 mb-2">
          Property Amenities
        </h2>
        <hr class="mb-4 border-gray-300" />
        <ul class="grid grid-cols-1 md:!grid-cols-2 lg:!grid-cols-3 list-disc list-inside text-gray-700">
          <li v-for="(amenity, index) in hotels?.value?.amenities" :key="index">
            {{ amenity }}
          </li>
        </ul>
      </div>
      <!-- R2B Extras Section -->
      <div class="bg-stone-100 p-4 rounded-lg mb-4" v-if="hotels?.value?.listing?.r2b_property_details?.extras?.length">
        <h2 class="text-base font-semibold leading-6 text-stone-700 mb-2">
          Extras
        </h2>
        <hr class="mb-4 border-gray-300" />
        
        <!-- Loop through each extra -->
        <div 
          v-for="(extra, index) in hotels.value.listing.r2b_property_details.extras" 
          :key="index"
          class="mb-4"
        >
          <div class="flex items-center text-sm text-stone-600">
            <div class="w-8 text-center"><i class="fa fa-circle text-xs"></i></div>
            <div class="flex-grow font-bold">
              {{ extra.extra_name }}
            </div>
          </div>
          <div class="mt-2 mb-4">
            <ul class="text-sm text-stone-600 ml-8">
              <li>
                <span class="font-medium">Charge Type:</span> 
                {{ formatChargeType(extra.charge_type) }}
              </li>
              <li>
                <span class="font-medium">Cost:</span> 
                AUD ${{ extra.cost }} 
                <small class="text-xs text-gray-500">(Inc. GST)</small>
              </li>
              <li>
                <span class="font-medium">Type:</span> 
                {{ extra.type === '1' || extra.type === 1 ? 'Mandatory' : 'Optional' }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- R2B Rules Section -->
      <div class="bg-stone-100 p-4 rounded-lg mb-4" v-if="hotels?.value?.listing?.r2b_property_details?.rules?.length">
        <h2 class="text-base font-semibold leading-6 text-stone-700 mb-2">
          Rules
        </h2>
        <hr class="mb-4 border-gray-300" />
        
        <div 
          v-for="(rule, index) in hotels.value.listing.r2b_property_details.rules" 
          :key="index"
          class="mb-4"
        >
          <div class="flex items-center text-sm text-stone-600">
            <div class="w-8 text-center"><i class="fa fa-circle text-xs"></i></div>
            <div class="flex-grow font-bold">
              {{ rule.rule_name }}
            </div>
          </div>
          <div class="mt-2 mb-4">
            <ul class="text-sm text-stone-600 ml-8">
              <li>
                <span class="font-medium">Condition:</span> 
                {{ rule.rule_condition }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- R2B Cancellation Policy Section -->
      <div class="bg-stone-100 p-4 rounded-lg mb-4" v-if="cancellationPolicyText">
        <h2 class="text-base font-semibold leading-6 text-stone-700 mb-2">
          Cancellation Policy
        </h2>
        <hr class="mb-4 border-gray-300" />
        <div
          class="text-sm text-stone-600 ml-2 whitespace-pre-line break-words p-4 border-gray-200"
          v-text="cancellationPolicyText"
        ></div>
      </div>
      <div class="bg-stone-100 p-4 rounded-lg mb-4" v-if="hotels?.value?.roomAmenities?.length">
        <h2 class="text-base font-semibold leading-6 text-stone-700 mb-2">
          Room Amenities
        </h2>
        <hr class="mb-4 border-gray-300" />
        <ul class="grid grid-cols-1 md:!grid-cols-2 lg:!grid-cols-3 list-disc list-inside text-gray-700">
          <li v-for="(amenity, index) in hotels?.value?.roomAmenities" :key="index">
            {{ amenity }}
          </li>
        </ul>
      </div>
      <div class="bg-stone-100 p-4 rounded-lg mb-4" v-if="hotels?.value?.content?.attributes?.general?.length">
        <ul class="grid grid-cols-1 md:!grid-cols-2 lg:!grid-cols-3 list-disc list-inside text-gray-700">
          <li v-for="(amenity, index) in hotels?.value?.content?.attributes
            ?.general" :key="index">
            {{ amenity }}
          </li>
        </ul>
      </div>
      <div class="mb-4 bg-stone-100 shadow-sm sm:rounded-lg" v-if="hotels?.value?.content?.metapolicy_extra_info?.length">
        <div class="border-b border-stone-300 p-4 sm:px-6">
          <h3 class="text-base font-semibold leading-6 text-stone-700">
            Additional Information
          </h3>
        </div>
        <div class="p-4 sm:p-6 text-sm text-stone-900">
          <!-- Try these different paths -->
          <span v-html="hotels?.value?.content?.metapolicy_extra_info"></span>
          <!-- or -->
        </div>
      </div>
      <div class="my-6" v-if="hotels?.value?.content?.metapolicy_struct">
        <h3 class="mb-2 text-base font-semibold leading-6 text-stone-700">
          Policies
        </h3>
        <PolicySection :meta-policy-struct="hotels?.value?.content?.metapolicy_struct" class="mt-8" />
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, reactive, computed, onMounted, onUnmounted, nextTick, watch } from "vue";
  import api from "../../utils/api.js";
  import ImageSlider from "../../src/UI/imageSlider.vue";
  import PolicySection from "../../src/UI/PolicySection.vue";
  import { useSearchStore } from "../../stores/search.module";
  import { useBookingStore } from "../../stores/booking.module.js";
  import { useComponentChangeStore } from "../../stores/componentChange.module.js";
  import { roundPrice, formatPrice } from "../../utils/imageFunction.js";
  import MainLoader from "../../src/UI/mainLoader.vue";
  import { isArray } from "lodash";
  import { API_URL } from "../../src/constants.js";
  import Toast from "../../src/UI/toast.vue";
  import flatpickr from "flatpickr";
  import "flatpickr/dist/flatpickr.css";

  if (typeof Date.prototype.fp_incr === 'undefined') {
    Date.prototype.fp_incr = function(days) {
      const result = new Date(this);
      result.setDate(result.getDate() + days);
      return result;
    };
  }
  
  const bookingStore = useBookingStore();
  const searchStore = useSearchStore();
  const componentChangeStore = useComponentChangeStore();
  
  const defaultImage = API_URL + `/images/image-not-found.jpg`;
  const toastRef = ref(null);
  const showDialog = ref(false);
  const searchHotelNameDetail = ref("");
  const hotels = reactive({});

  const decodeHtmlEntities = (value) => {
    if (typeof value !== "string") return "";
    if (typeof document === "undefined") return value;

    const textarea = document.createElement("textarea");
    textarea.innerHTML = value;
    return textarea.value;
  };

  const cancellationPolicyText = computed(() => {
    const raw =
      hotels.value?.content?.cancellation_policy_text ??
      hotels.value?.listing?.r2b_property_details?.cancellation_policy_text ??
      "";
    if (!raw) return "";

    const decoded =
      raw.includes("&lt;") || raw.includes("&gt;") || raw.includes("&amp;")
        ? decodeHtmlEntities(raw)
        : raw;

    return decoded.replace(/<br\s*\/?>/gi, "\n").replace(/\r\n/g, "\n").trim();
  });
  
  const checkinDate = ref();
  const checkoutDate = ref();
  const rooms = ref([{ adults: 2, children: 0, ages: [] }]);
const r2bToday = new Date();
let r2bCheckinPicker = null;
let r2bCheckoutPicker = null;
let r2bPickersCleanup = null;
let r2bPickersInitialized = false;

const setr2bDefaultDates = () => {
  const checkinDate = new Date(r2bToday);
  checkinDate.setDate(r2bToday.getDate() + 14);

  const checkoutDate = new Date(r2bToday);
  checkoutDate.setDate(r2bToday.getDate() + 16);

  r2bCheckin.value = checkinDate;
  r2bCheckout.value = checkoutDate;
};

const initializer2bDatePickers = () => {
  const checkInEl = document.querySelector("#r2bCheckInDate");
  const checkOutEl = document.querySelector("#r2bCheckOutDate");
  if (!checkInEl || !checkOutEl) return () => {};

  if (!r2bCheckin.value || !r2bCheckout.value) {
    setr2bDefaultDates();
  }

  if (r2bCheckinPicker) {
    try {
      r2bCheckinPicker.destroy();
    } catch (e) {
      // ignore
    }
    r2bCheckinPicker = null;
  }
  if (r2bCheckoutPicker) {
    try {
      r2bCheckoutPicker.destroy();
    } catch (e) {
      // ignore
    }
    r2bCheckoutPicker = null;
  }

  // === Extract R2B calendar configuration ===
  const isR2B = hotels.value?.listing?.r2bPropertyDetails;
  const bookedDates = hotels.value?.listing?.r2b_property_availability?.availability?.booked_dates || [];
  const minNotice = hotels.value?.listing?.r2bPropertyDetails?.min_notice || 0;
  const createdAt = hotels.value?.listing?.created_at ? new Date(hotels.value.listing.created_at) : new Date();
  const minAllowedDateTime = new Date(createdAt.getTime() + minNotice * 60 * 60 * 1000);
  const today = new Date();
  const calculatedMinDateTime = minAllowedDateTime > today ? minAllowedDateTime : today;
  const calculatedMinDate = isR2B ? calculatedMinDateTime.toISOString().split('T')[0] : today.toISOString().split('T')[0];

  const maxDate = (() => {
    const date = new Date();
    date.setDate(date.getDate() + 365);
    return date;
  })();

  // Shared disable function for date validation (from R2B)
  const getDisableFunction = () => {
    return function(date) {
      const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      const minDateOnly = new Date(calculatedMinDateTime.getFullYear(),
        calculatedMinDateTime.getMonth(), calculatedMinDateTime.getDate());

      if (dateOnly < minDateOnly) {
        return true;
      }

      if (dateOnly.getTime() === minDateOnly.getTime()) {
        const now = new Date();
        return now < calculatedMinDateTime;
      }

      return false;
    };
  };

  // Shared day styling function (from R2B)
  const onDayCreate = (dObj, dStr, fp, dayElem) => {
    if (dayElem.classList.contains('flatpickr-disabled')) {
      dayElem.style.color = '#dc2626';
      dayElem.style.cursor = 'not-allowed';
    }
  };

  // Helper to check date conflicts (from R2B)
  const hasDateConflict = (checkInTime, checkOutTime) => {
    for (let i = 0; i < bookedDates.length; i++) {
      const bookedDate = new Date(bookedDates[i]);
      const bookedTime = bookedDate.getTime();
      if (bookedTime > checkInTime && bookedTime < checkOutTime) {
        return true;
      }
    }
    return false;
  };

  // Flag to prevent recursive clearing
  let isClearingCheckout = false;

  // === Initialize r2b Check-Out Calendar with R2B logic ===
  r2bCheckoutPicker = flatpickr("#r2bCheckOutDate", {
    altInput: true,
    altFormat: "j F, Y",
    dateFormat: "Y-m-d",
    defaultDate: r2bCheckout.value,
    maxDate: maxDate,
    minDate: calculatedMinDate,
    inline: true,
    static: true,
    disable: [...bookedDates, getDisableFunction()],
    onDayCreate: onDayCreate,
    onChange: (selectedDates, dateStr) => {
      if (isClearingCheckout) return;

      const selectedCheckOut = new Date(dateStr);
      
      // Validate check-in exists
      if (!r2bCheckin.value) {
        if (toastRef.value) {
          toastRef.value.addToast("Please select a check-in date first", "error");
        }
        isClearingCheckout = true;
        r2bCheckoutPicker.clear();
        setTimeout(() => { isClearingCheckout = false; }, 100);
        return;
      }

      const selectedCheckIn = new Date(r2bCheckin.value);
      
      // Validate checkout is after checkin
      if (selectedCheckOut <= selectedCheckIn) {
        if (toastRef.value) {
          toastRef.value.addToast("Check-out date must be after check-in date", "error");
        }
        isClearingCheckout = true;
        r2bCheckoutPicker.clear();
        setTimeout(() => { isClearingCheckout = false; }, 100);
        return;
      }

      // Check for date conflicts
      if (hasDateConflict(selectedCheckIn.getTime(), selectedCheckOut.getTime())) {
        alert("The selected dates overlap with booked dates. Please choose different dates");
        isClearingCheckout = true;
        r2bCheckoutPicker.clear();
        setTimeout(() => { isClearingCheckout = false; }, 100);
        return;
      }

      // Update values and storage
      r2bCheckout.value = dateStr;
      r2bCheckout.value = dateStr;
      localStorage.setItem("r2b_dates", JSON.stringify({
        checkin: r2bCheckin.value,
        checkout: dateStr
      }));
    }
  });

  // === Initialize r2b Check-In Calendar with R2B logic ===
  r2bCheckinPicker = flatpickr("#r2bCheckInDate", {
    altInput: true,
    altFormat: "j F, Y",
    dateFormat: "Y-m-d",
    defaultDate: r2bCheckin.value,
    inline: true,
    static: true,
    disable: [...bookedDates, getDisableFunction()],
    minDate: calculatedMinDate,
    maxDate: maxDate,
    onDayCreate: onDayCreate,
    onChange: (selectedDates, dateStr) => {
      const selectedCheckIn = new Date(dateStr);
      const minNights = hotels.value?.content?.min_nights || 2;
      
      // Calculate new checkout constraints
      const minCheckoutDate = new Date(selectedCheckIn);
      minCheckoutDate.setDate(minCheckoutDate.getDate() + 1);
      
      const maxCheckoutDate = new Date(selectedCheckIn);
      maxCheckoutDate.setDate(maxCheckoutDate.getDate() + 30);
      
      const defaultCheckout = new Date(selectedCheckIn);
      defaultCheckout.setDate(defaultCheckout.getDate() + minNights);

      // Update checkout calendar constraints
      r2bCheckoutPicker.set("minDate", minCheckoutDate);
      r2bCheckoutPicker.set("maxDate", maxCheckoutDate);
      r2bCheckoutPicker.setDate(defaultCheckout);

      // Update reactive values
      r2bCheckin.value = dateStr;
      r2bCheckin.value = dateStr;
      const checkoutDateStr = defaultCheckout.toISOString().split('T')[0];
      r2bCheckout.value = checkoutDateStr;
      r2bCheckout.value = checkoutDateStr;
      
      // Save to localStorage
      localStorage.setItem("r2b_dates", JSON.stringify({
        checkin: dateStr,
        checkout: checkoutDateStr
      }));

      // Validate existing checkout selection
      const selectedCheckOut = r2bCheckoutPicker.selectedDates[0];
      if (selectedCheckOut) {
        if (hasDateConflict(selectedCheckIn.getTime(), selectedCheckOut.getTime())) {
          alert("The selected dates overlap with booked dates. Please choose different dates");
          r2bCheckoutPicker.clear();
          r2bCheckout.value = null;
          r2bCheckout.value = null;
        }
      }
    },
  });

  // Add scroll event listener to close pickers
  const handleScroll = () => {
    r2bCheckinPicker?.close();
    r2bCheckoutPicker?.close();
  };

  window.addEventListener("scroll", handleScroll);

  return () => {
    window.removeEventListener("scroll", handleScroll);
    try {
      r2bCheckinPicker?.destroy();
    } catch (e) {
      // ignore
    }
    try {
      r2bCheckoutPicker?.destroy();
    } catch (e) {
      // ignore
    }
    r2bCheckinPicker = null;
    r2bCheckoutPicker = null;
  };
};

const tryInitializer2bPickers = () => {
  if (r2bPickersInitialized) return;
  const checkInEl = document.querySelector("#r2bCheckInDate");
  const checkOutEl = document.querySelector("#r2bCheckOutDate");
  if (!checkInEl || !checkOutEl) return;
  r2bPickersCleanup = initializer2bDatePickers();
  r2bPickersInitialized = true;
};

  const r2bAdults = ref(1);
  const r2bChildren = ref(0);
  const r2bInfants = ref(0);
  const r2bCheckin = ref(null);
  const r2bCheckout = ref(null);
  const checkAvailabilityFlag = ref(false);
  const isCheckingAvailability = ref(false);
  let R2BCalendarCheckInDate = null;
  let calendarCheckOutDate = null;
  
  const addRoom = () => {
    rooms.value.push({ adults: 1, children: 0, ages: [] });
  };
  
  const removeRoom = (index) => {
    if (rooms.value.length > 1) {
      rooms.value.splice(index, 1);
    }
  };
  
  const validateAdults = (room) => {
    room.adults = Math.min(6, Math.max(1, room.adults));
  };
  
  const validateChildren = (room) => {
    room.children = Math.min(4, Math.max(0, room.children));
    room.ages = room.ages.slice(0, room.children); // Adjust ages array if children count changes
  };
  
  // Enforce child age limit (0-17)
  const validateChildAge = (room, index) => {
    room.ages[index] = Math.min(17, Math.max(0, room.ages[index]));
  };
  
  const openImageDialog = (room) => {
    selectedRoomForImages.value = room;
  };
  
  const openPriceDialog = (room) => {
    selectedRoomForPrice.value = room;
  };
  
  const openPolicyDialog = (room) => {
    selectedRoomForPolicy.value = room;
  };
  
  
  const getMapUrl = computed(() => {
    const lat = hotels.value?.content?.location?.coordinates?.latitude;
    const lng = hotels.value?.content?.location?.coordinates?.longitude;
  
    if (lat && lng) {
      return `https://maps.google.com/maps?width=600&height=400&hl=en&q=${lat},${lng}&t=&z=15&ie=UTF8&iwloc=B&output=embed`;
    }
    return null;
  });

  const r2bMaxAdults = computed(() => {
    const max = Number(hotels.value?.listing?.r2b_property_details?.max_adults);
    return Number.isFinite(max) && max > 0 ? max : null;
  });

  const r2bMaxChildren = computed(() => {
    const max = Number(hotels.value?.listing?.r2b_property_details?.max_children);
    return Number.isFinite(max) && max >= 0 ? max : null;
  });

  const r2bMaxInfants = computed(() => {
    const max = Number(hotels.value?.listing?.r2b_property_details?.max_infants);
    return Number.isFinite(max) && max >= 0 ? max : null;
  });

  const clampInt = (value, min, maxOrNull) => {
    const asNumber = Number(value);
    const asInt = Number.isFinite(asNumber) ? Math.trunc(asNumber) : min;
    const minClamped = Math.max(min, asInt);
    if (maxOrNull === null) return minClamped;
    return Math.min(maxOrNull, minClamped);
  };

  const GUEST_KEYS = ["adults", "children", "infants"];
  const guestConfig = computed(() => ({
    adults: {
      min: 1,
      value: r2bAdults,
      max: r2bMaxAdults,
      message: (maxValue) => `Max guest adult limit is ${maxValue}`,
    },
    children: {
      min: 0,
      value: r2bChildren,
      max: r2bMaxChildren,
      message: (maxValue) => `Max guest children limit is ${maxValue}`,
    },
    infants: {
      min: 0,
      value: r2bInfants,
      max: r2bMaxInfants,
      message: (maxValue) => `Max guest infant limit is ${maxValue}`,
    },
  }));

  const lastLimitToastAt = ref({ adults: 0, children: 0, infants: 0 });
  const maybeShowLimitToast = (key) => {
    const cfg = guestConfig.value[key];
    const maxValue = cfg.max.value;
    if (!toastRef.value || maxValue === null) return;
    const now = Date.now();
    const last = lastLimitToastAt.value[key] ?? 0;
    if (now - last < 1000) return; // prevent spamming while user types/holds increment
    lastLimitToastAt.value = { ...lastLimitToastAt.value, [key]: now };
    toastRef.value.addToast(cfg.message(maxValue), "error");
  };

  const isAtOrAboveMax = (key) => {
    const cfg = guestConfig.value[key];
    const maxValue = cfg.max.value;
    return maxValue !== null && cfg.value.value >= maxValue;
  };

  const handleGuestKeydown = (key, event) => {
    if (event?.key === "ArrowUp" && isAtOrAboveMax(key)) maybeShowLimitToast(key);
  };

  const handleGuestWheel = (key, event) => {
    if (event?.deltaY < 0 && isAtOrAboveMax(key)) maybeShowLimitToast(key);
  };

  const handleGuestMouseDown = (key, event) => {
    if (!event || event.button !== 0 || !isAtOrAboveMax(key)) return;
    const spinZoneWidth = 24;
    const x = event.offsetX;
    const y = event.offsetY;
    const input = event.currentTarget;
    if (!input) return;
    const isSpinZone = x >= input.clientWidth - spinZoneWidth;
    const isIncrementHalf = y <= input.clientHeight / 2;
    if (isSpinZone && isIncrementHalf) maybeShowLimitToast(key);
  };
  
  const updateCheckoutMinDate = () => {
    if (checkoutDate.value && checkoutDate.value < minCheckoutDate.value) {
      checkoutDate.value = minCheckoutDate.value;
    }
  };
  
  const minCheckoutDate = computed(() => {
    if (!checkinDate.value) return ""; // If no check-in selected
    const date = new Date(checkinDate.value);
    date.setDate(date.getDate() + 2); // Add 2 days
    return date.toISOString().split("T")[0]; // Convert to YYYY-MM-DD
  });

  const formattedCheckin = computed(() => {
    if (!r2bCheckin.value) return "";
    const date = new Date(r2bCheckin.value);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  });

  const formattedCheckout = computed(() => {
    if (!r2bCheckout.value) return "";
    const date = new Date(r2bCheckout.value);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  });

  const bookingPrice = computed(() => {
    if (!hotels.value?.content?.price) return "AUD $0.00";
    return `AUD $${roundPrice(hotels.value.content.price)}`;
  });

  const showBookingButton = computed(() => {
    return checkAvailabilityFlag.value && r2bCheckin.value && r2bCheckout.value;
  });
  
  const getFullAdress = computed(() => {
    return `${hotels.value?.content?.address?.line_1 !== null
      ? hotels.value?.content?.address?.line_1
      : ""
      }, ${hotels.value?.content?.address?.city !== null
        ? hotels.value?.content?.address?.city
        : ""
      }, ${hotels.value?.content?.address?.state_province_name !== null
        ? hotels.value?.content?.address?.state_province_name
        : ""
      }, ${hotels.value?.content?.address?.postal_code !== null
        ? hotels.value?.content?.address?.postal_code
        : ""
      } `;
  });
  const getFullAdressForAffliate = computed(() => {
    return `${hotels.value?.listing?.address_line1 !== null
      ? hotels.value?.listing?.address_line1
      : ""
      }, ${hotels.value?.listing?.address_line2 !== null
        ? hotels.value?.listing?.address_line2
        : ""
      },${hotels.value?.listing?.postcode !== null
        ? hotels.value?.listing?.postcode
        : ""
      },${hotels.value?.listing?.suburb !== null ? hotels.value?.listing?.suburb : ""
      },
     ${hotels.value?.listing?.county !== null ? hotels.value?.listing?.county : ""
      }, ${hotels.value?.listing?.country !== null
        ? hotels.value?.listing?.country
        : ""
      } `;
  });
  const propertyId = computed(() => {
    return searchStore.getSelectedPropertyId;
  });
  const selectedPropertyName = computed(() => {
    return searchStore.getSelectedHotelName;
  });
  
  const occupancy = computed(() => {
    const rooms = searchStore.getRooms;
  
    // Check if the rooms data is already in the formatted occupancy format
    if (typeof rooms === "string") {
      return rooms; // Return it directly if it's already in the correct format
    }
  
    // If rooms is not in the formatted string, format it
    if (Array.isArray(rooms)) {
      const formattedOccupancy = rooms
        .map((room, index) => {
          const adultsCount = room.adults;
          const childrenAges = room.ages.length > 0 ? room.ages.join(",") : "";
          return `occupancy[${index}]=${adultsCount}-${childrenAges}`;
        })
        .join("&");
      return formattedOccupancy;
    }
  
    return ""; // Return empty string if `rooms` is neither an array nor a formatted string
  });
  
  const slugifiedPropertyName = computed(() => {
    return selectedPropertyName.value
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, "") // Remove special characters
      .replace(/[\s_-]+/g, "-") // Replace spaces or underscores with a single dash
      .replace(/^-+|-+$/g, ""); // Remove dashes at the beginning or end
  });
  
const getAmenityIcon = (amenity) => {
  if (!amenity) return null;
  const iconName = amenity.toLowerCase().replace(/\s+/g, "-") + ".svg";
  return `${API_URL}/images/amenities/${iconName}`;
};

const formatR2BDate = (dateString) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  
  return `${day}-${month}-${year}`;
};

  const formatChargeType = (chargeType) => {
  if (!chargeType) return '';
  
  return chargeType
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
  
  // Initialize R2B calendars
  const initializeR2BCalendars = () => {
    // Check if the calendar elements exist in the DOM
    const checkInInput = document.querySelector("#R2BCalendarCheckInDate");
    const checkOutInput = document.querySelector("#R2BCalendarCheckoutDate");
    const checkInInline = document.querySelector("#calendarCheckInDateInline");
    const checkOutInline = document.querySelector("#calendarCheckOutDateInline");
    
    if (!checkInInput || !checkOutInput || !checkInInline || !checkOutInline) {
      return;
    }

    // Cleanup existing instances
    const destroyCalendars = () => {
      if (R2BCalendarCheckInDate) {
        try {
          R2BCalendarCheckInDate.destroy();
        } catch (e) {
          // Silent error handling
        }
        R2BCalendarCheckInDate = null;
      }
      if (calendarCheckOutDate) {
        try {
          calendarCheckOutDate.destroy();
        } catch (e) {
          // Silent error handling
        }
        calendarCheckOutDate = null;
      }
    };

    destroyCalendars();

    // Calculate calendar configuration values
    const isR2B = hotels.value?.listing?.r2bPropertyDetails;
    const bookedDates = hotels.value?.listing?.r2b_property_availability?.availability?.booked_dates || [];
    const minNotice = hotels.value?.listing?.r2bPropertyDetails?.min_notice || 0;
    const createdAt = hotels.value?.listing?.created_at ? new Date(hotels.value.listing.created_at) : new Date();
    const minAllowedDateTime = new Date(createdAt.getTime() + minNotice * 60 * 60 * 1000);
    const today = new Date();
    const calculatedMinDateTime = minAllowedDateTime > today ? minAllowedDateTime : today;
    const calculatedMinDate = isR2B ? calculatedMinDateTime.toISOString().split('T')[0] : today.toISOString().split('T')[0];

    // Default dates
    const defaultCheckin = r2bCheckin.value || (() => {
      const date = new Date();
      date.setDate(date.getDate() + 14);
      return date.toISOString().split('T')[0];
    })();

    const defaultCheckout = r2bCheckout.value || (() => {
      const date = new Date();
      date.setDate(date.getDate() + 16);
      return date.toISOString().split('T')[0];
    })();

    const maxDate = (() => {
      const date = new Date();
      date.setDate(date.getDate() + 365);
      return date;
    })();

    // Shared disable function for date validation
    const getDisableFunction = () => {
      return function(date) {
        const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        const minDateOnly = new Date(calculatedMinDateTime.getFullYear(),
          calculatedMinDateTime.getMonth(), calculatedMinDateTime.getDate());

        if (dateOnly < minDateOnly) {
          return true;
        }

        if (dateOnly.getTime() === minDateOnly.getTime()) {
          const now = new Date();
          return now < calculatedMinDateTime;
        }

        return false;
      };
    };

    // Shared day styling function
    const onDayCreate = (dObj, dStr, fp, dayElem) => {
      if (dayElem.classList.contains('flatpickr-disabled')) {
        dayElem.style.color = '#dc2626';
        dayElem.style.cursor = 'not-allowed';
      }
    };

    // Helper to check date conflicts
    const hasDateConflict = (checkInTime, checkOutTime) => {
      for (let i = 0; i < bookedDates.length; i++) {
        const bookedDate = new Date(bookedDates[i]);
        const bookedTime = bookedDate.getTime();
        if (bookedTime > checkInTime && bookedTime < checkOutTime) {
          return true;
        }
      }
      return false;
    };

    // Helper to update input display
    const updateInputDisplay = (input, dateStr) => {
      if (input) {
        const date = new Date(dateStr);
        input.value = date.toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' });
      }
    };

    // Flag to prevent recursive clearing
    let isClearingCheckout = false;


    
    // Set initial input field values
    updateInputDisplay(checkInInput, r2bCheckin.value);
    updateInputDisplay(checkOutInput, r2bCheckout.value);

    // Return cleanup function (optional use)
    return destroyCalendars;
  };

  const checkAvailability = () => {
    if (!r2bCheckin.value || !r2bCheckout.value) {
      if (toastRef.value) {
        toastRef.value.addToast("Please select both check-in and check-out dates from calendars", "error");
      }
      return;
    }

    if (r2bAdults.value < 1) {
      if (toastRef.value) {
        toastRef.value.addToast("At least 1 adult is required", "error");
      }
      return;
    }

    // Sync r2b values from r2b calendars
    r2bCheckin.value = r2bCheckin.value;
    r2bCheckout.value = r2bCheckout.value;

    checkAvailabilityFlag.value = true;
    getR2BPropertyData();
  };

  const resetR2BForm = () => {
    r2bAdults.value = 1;
    r2bChildren.value = 0;
    r2bInfants.value = 0;
    checkAvailabilityFlag.value = false;
    isCheckingAvailability.value = false;
    
    localStorage.removeItem("r2b_guest_details");
    localStorage.removeItem("r2b_dates");
    
    const today = new Date();
    today.setDate(today.getDate() + 14);
    r2bCheckin.value = today.toISOString().split('T')[0];
    r2bCheckin.value = r2bCheckin.value;
    
    const checkout = new Date(today);
    checkout.setDate(checkout.getDate() + 2);
    r2bCheckout.value = checkout.toISOString().split('T')[0];
    r2bCheckout.value = r2bCheckout.value;

    localStorage.setItem("r2b_dates", JSON.stringify({
      checkin: r2bCheckin.value,
      checkout: r2bCheckout.value
    }));

    // Reset r2b calendars (primary booking calendars)
    if (r2bCheckinPicker) {
      r2bCheckinPicker.setDate(today);
    }
    if (r2bCheckoutPicker) {
      r2bCheckoutPicker.setDate(checkout);
    }

    // Also reset R2B inline calendars (display only)
    if (R2BCalendarCheckInDate) {
      R2BCalendarCheckInDate.setDate(today);
    }
    if (calendarCheckOutDate) {
      calendarCheckOutDate.setDate(checkout);
    }

    getR2BPropertyData();
  };

  const getR2BPropertyData = () => {
    if (!propertyId.value || !r2bCheckin.value || !r2bCheckout.value) {
      return;
    }
    isCheckingAvailability.value = true;

    const propertyDetailsPayload = {
      propertyId: propertyId.value,
      slugifiedPropertyName: slugifiedPropertyName.value,
      checkin: r2bCheckin.value,
      checkout: r2bCheckout.value,
      adults: r2bAdults.value,
      children: r2bChildren.value,
      infants: r2bInfants.value,
      check_availability: checkAvailabilityFlag.value ? 'true' : ''
    };

    // Save to localStorage including guest details
    localStorage.setItem(
      "propertyDetailsPayload",
      JSON.stringify(propertyDetailsPayload)
    );
        localStorage.setItem("r2b_guest_details", JSON.stringify({
      adults: r2bAdults.value,
      children: r2bChildren.value,
      infants: r2bInfants.value
    }));
    
    localStorage.setItem("r2b_dates", JSON.stringify({
      checkin: r2bCheckin.value,
      checkout: r2bCheckout.value
    }));
    const formatDate = (date) => {
      if (!date) return '';
      if (typeof date === 'string' && date.match(/^\d{4}-\d{2}-\d{2}$/)) {
        return date; // Already in correct format
      }
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const apiParams = {
      checkin: formatDate(propertyDetailsPayload.checkin),
      checkout: formatDate(propertyDetailsPayload.checkout),
      'rooms[0][adults]': propertyDetailsPayload.adults,
      'rooms[0][children]': propertyDetailsPayload.children,
      'rooms[0][infants]': propertyDetailsPayload.infants,
      check_availability: propertyDetailsPayload.check_availability,
    };

    api
      .get(
        `/property/details/${propertyDetailsPayload.propertyId}/${propertyDetailsPayload.slugifiedPropertyName}`, {
        params: apiParams
      }
      )
      .then((res) => {
        hotels.value = res.data.data;        
        if (res.data.data?.listing?.third_party_type) {
          localStorage.setItem(`third_party_type_${propertyId.value}`, res.data.data.listing.third_party_type);
        }
        if (toastRef.value && checkAvailabilityFlag.value) {
          toastRef.value.addToast("Availability checked successfully!", "success");
        }
        
        // Reinitialize calendars if R2B
        if (res.data.data?.listing?.r2bPropertyDetails) {
          nextTick(() => {
            setTimeout(() => {
              initializeR2BCalendars();
            }, 100);
          });
        }
      }      )
      .catch((err) => {
        if (toastRef.value) {
          toastRef.value.addToast(`${err.response?.data?.message || 'There is some issue while fetching the hotel details'}`, "error");
        }
      })
      .finally(() => {
        isCheckingAvailability.value = false;
      });
  };

  const bookR2BProperty = async () => {
    if (!r2bCheckin.value || !r2bCheckout.value) {
      if (toastRef.value) {
        toastRef.value.addToast("Please select check-in and check-out dates from calendars", "error");
      }
      return;
    }

    r2bCheckin.value = r2bCheckin.value;
    r2bCheckout.value = r2bCheckout.value;

    // Prepare payload for checkout API
    const checkoutPayload = {
      listing_id: hotels.value?.listing?.id || "",
      checkin: r2bCheckin.value,
      checkout: r2bCheckout.value,
      adults: r2bAdults.value,
      children: r2bChildren.value,
      infants: r2bInfants.value,
    };

    try {
      // Show loading state
      isCheckingAvailability.value = true;

      // Call the R2B checkout API
      const response = await api.post("/property/r2b-checkout", checkoutPayload);

      if (response.data && response.data.data) {
        const apiResponseData = response.data.data;

        const bookingData = {
          rate_id: hotels.value?.listing?.advertised_price || "",
          room_id: hotels.value?.listing?.listing_name || "",
          book_hash: "",
          meal: "",
          listing_id: hotels.value?.listing?.id || "",
          property_id: hotels.value?.propertyId || "",
          checkin: r2bCheckin.value,
          checkout: r2bCheckout.value,
          third_party_type: "REQUESTTOBOOK",
          adults: r2bAdults.value,
          children: r2bChildren.value,
          infants: r2bInfants.value,
          r2bCheckoutData: apiResponseData,
        };

        bookingStore.addValueToBookingRoom(bookingData);
        localStorage.setItem("bookingData", JSON.stringify(bookingData));

        const urlParams = new URLSearchParams(window.location.search);
        const tabId = urlParams.get("tabId");
        const currentTabId = tabId || localStorage.getItem("currentTabId") || "main_tab";

        localStorage.setItem(`componentLoad_${currentTabId}`, "bookingView");
        localStorage.setItem("componentLoad", "bookingView");

        const currentUrl = new URL(window.location.href);

        if (!currentUrl.searchParams.has('propertyId') && propertyId.value) {
          currentUrl.searchParams.set('propertyId', propertyId.value);
        }

        if (!currentUrl.searchParams.has('propertyName') && slugifiedPropertyName.value) {
          currentUrl.searchParams.set('propertyName', slugifiedPropertyName.value);
        }

        if (!currentUrl.searchParams.has('tabId') && currentTabId) {
          currentUrl.searchParams.set('tabId', currentTabId);
        }

        currentUrl.searchParams.set('view', 'bookingView');
        window.history.replaceState({}, '', currentUrl.toString());

        document.body.style.overflow = "auto";
        componentChangeStore.changeTheComponent("bookingView");

        if (toastRef.value) {
          toastRef.value.addToast(response.data.message || "Checkout data retrieved successfully", "success");
        }
      }
    } catch (err) {
      if (toastRef.value) {
        toastRef.value.addToast(
          err.response?.data?.message || "Failed to process checkout. Please try again.",
          "error"
        );
      }
    } finally {
      isCheckingAvailability.value = false;
    }
  };

  onMounted(() => {
    restoreStoreData();
  
    const storedCheckin = localStorage.getItem("selectedCheckin");
    const storedCheckout = localStorage.getItem("selectedCheckout");
  
    if (storedCheckin && storedCheckout) {
      checkinDate.value = storedCheckin;
      checkoutDate.value = storedCheckout;
      r2bCheckin.value = storedCheckin;
      r2bCheckout.value = storedCheckout;
      r2bCheckin.value = storedCheckin;
      r2bCheckout.value = storedCheckout;
    } else if (!checkinDate.value || !checkoutDate.value) {
      const today = new Date();
      today.setDate(today.getDate() + 14);
      checkinDate.value = today.toISOString().split('T')[0];
      r2bCheckin.value = checkinDate.value;
      r2bCheckin.value = checkinDate.value;
  
      const checkoutDay = new Date(today);
      checkoutDay.setDate(checkoutDay.getDate() + 2);
      checkoutDate.value = checkoutDay.toISOString().split('T')[0];
      r2bCheckout.value = checkoutDate.value;
      r2bCheckout.value = checkoutDate.value;
    }
  
    searchStore.setCheckin(checkinDate.value);
    searchStore.setCheckout(checkoutDate.value);
  
    getPropertyData();

  setTimeout(() => {
    const checkIn = document.querySelector("#R2BCalendarCheckInDate");
    const checkOut = document.querySelector("#R2BCalendarCheckoutDate");
    
    if (checkIn && checkOut) {
      initializeR2BCalendars();
    }
  }, 500);

  // r2b flatpickr: try on mount (will no-op if loader is showing and inputs aren't rendered yet)
  nextTick(() => {
    tryInitializer2bPickers();
  });
});

// When hotel data finishes loading, the template renders the r2b inputs.
// Initialize r2b flatpickr then (this is the key difference vs search.vue which always renders its inputs).
watch(
  () => hotels.value?.content?.name,
  (name) => {
    if (!name) return;
    nextTick(() => {
      // Reset initialization flag to allow re-init with new hotel data
      r2bPickersInitialized = false;
      tryInitializer2bPickers();
    });
  }
);

watch(() => hotels.value?.listing, (newVal) => {
  if (newVal && newVal.r2bPropertyDetails) {
    nextTick(() => {
      setTimeout(() => {
        initializeR2BCalendars();
      }, 100);
    });
  }
}, { immediate: true, deep: true });
watch([r2bAdults, r2bChildren, r2bInfants, r2bMaxAdults, r2bMaxChildren, r2bMaxInfants], () => {
  const next = {};
  let changed = false;

  for (const key of GUEST_KEYS) {
    const cfg = guestConfig.value[key];
    const current = cfg.value.value;
    const maxValue = cfg.max.value;
    const nextValue = clampInt(current, cfg.min, maxValue);
    next[key] = nextValue;

    if (nextValue !== current) {
      changed = true;
      if (maxValue !== null && current > maxValue) maybeShowLimitToast(key);
    }
  }

  if (changed) {
    r2bAdults.value = next.adults;
    r2bChildren.value = next.children;
    r2bInfants.value = next.infants;
    return;
  }

  localStorage.setItem("r2b_guest_details", JSON.stringify({
    adults: r2bAdults.value,
    children: r2bChildren.value,
    infants: r2bInfants.value
  }));
});
  
  function openRoomDetails(room) {
    selectedRoom.value = room;
    showDialog.value = true;
  }
  
  function redirectToParterWebsite(url) {
    window.open(url, "_blank");
  }
  
  function restoreStoreData() {
    const storedData = JSON.parse(localStorage.getItem("propertyDetailsPayload"));
  
    if (storedData) {
      if (!searchStore.getSelectedPropertyId) {
        searchStore.setHotelRoomId(storedData.propertyId);
      }
  
      if (!searchStore.getSelectedHotelName) {
        searchStore.setHotelRoomName(storedData.slugifiedPropertyName);
      }
      
      searchStore.setRooms(storedData.rooms)
      rooms.value = storedData.rooms;
    }
    
    const storedDates = JSON.parse(localStorage.getItem("r2b_dates"));
    if (storedDates) {
      if (storedDates.checkin) {
        checkinDate.value = storedDates.checkin;
        r2bCheckin.value = storedDates.checkin;
        r2bCheckin.value = storedDates.checkin;
        searchStore.setCheckin(storedDates.checkin);
      }
      if (storedDates.checkout) {
        checkoutDate.value = storedDates.checkout;
        r2bCheckout.value = storedDates.checkout;
        r2bCheckout.value = storedDates.checkout;
        searchStore.setCheckout(storedDates.checkout);
      }
    } else if (storedData) {
      if (storedData.checkin) {
        checkinDate.value = storedData.checkin;
        r2bCheckin.value = storedData.checkin;
        r2bCheckin.value = storedData.checkin;
        searchStore.setCheckin(storedData.checkin);
      }
      if (storedData.checkout) {
        checkoutDate.value = storedData.checkout;
        r2bCheckout.value = storedData.checkout;
        r2bCheckout.value = storedData.checkout;
        searchStore.setCheckout(storedData.checkout);
      }
    }
      const storedGuestDetails = JSON.parse(localStorage.getItem("r2b_guest_details"));
    if (storedGuestDetails) {
      if (storedGuestDetails.adults !== undefined) {
        r2bAdults.value = storedGuestDetails.adults;
      }
      if (storedGuestDetails.children !== undefined) {
        r2bChildren.value = storedGuestDetails.children;
      }
      if (storedGuestDetails.infants !== undefined) {
        r2bInfants.value = storedGuestDetails.infants;
      }
    }
  }
  
  function getResetData() {
    const today = new Date();
    today.setDate(today.getDate() + 14);
    checkinDate.value = today.toISOString().split("T")[0];
  
    const checkout = new Date(today);
    checkout.setDate(checkout.getDate() + 2);
    checkoutDate.value = checkout.toISOString().split("T")[0];
  
    rooms.value = [{ adults: 2, children: 0, ages: [] }];
    getPropertyData();
  }
  
  function searchByHotelName() {
    if (!searchHotelNameDetail.value) {
      return;
    }
  
    searchStore.setsearchedHotelName(searchHotelNameDetail.value);
    let hotelName = { searchHotelName: searchHotelNameDetail.value }
    localStorage.setItem("searchedData", JSON.stringify(hotelName));
    localStorage.setItem("componentLoad", "mainView");
  
    componentChangeStore.changeTheComponent("mainView");
    localStorage.removeItem("propertyDetailsPayload")
  }
  
  
  function getPropertyData() {
    hotels.value = [];
    if (!propertyId.value) {
      return;
    }
  
    const storedType = localStorage.getItem(`third_party_type_${propertyId.value}`);
    const isR2B = storedType === 'REQUESTTOBOOK' || hotels.value?.listing?.third_party_type === 'REQUESTTOBOOK';
    
    if (isR2B) {
      if (!r2bCheckin.value || !r2bCheckout.value) {
        const today = new Date();
        today.setDate(today.getDate() + 14);
        r2bCheckin.value = today.toISOString().split('T')[0];
        
        const checkout = new Date(today);
        checkout.setDate(checkout.getDate() + 2);
        r2bCheckout.value = checkout.toISOString().split('T')[0];
      }
      getR2BPropertyData();
      return;
    }
  
    if (!checkinDate.value || !checkoutDate.value) {
      const today = new Date();
      checkinDate.value = today.toISOString().split('T')[0];
  
      const checkout = new Date(today);
      checkout.setDate(checkout.getDate() + 2);
      checkoutDate.value = checkout.toISOString().split('T')[0];
    }
    searchStore.setCheckin(checkinDate.value);
    searchStore.setCheckout(checkoutDate.value);
    searchStore.setRooms(rooms.value);
    const propertyDetailsPayload = {
      propertyId: propertyId.value,
      slugifiedPropertyName: slugifiedPropertyName.value,
      checkin: checkinDate.value,
      checkout: checkoutDate.value,
      rooms: rooms.value
    };
    localStorage.setItem(
      "propertyDetailsPayload",
      JSON.stringify(propertyDetailsPayload)
    );
    searchStore.setRooms(rooms.value)
    api
      .get(
        `/property/details/${propertyDetailsPayload.propertyId}/${propertyDetailsPayload.slugifiedPropertyName}`, {
        params: {
          checkin: propertyDetailsPayload.checkin,
          checkout: propertyDetailsPayload.checkout,
          rooms: propertyDetailsPayload.rooms,
        }
      }
      )
      .then((res) => {
        hotels.value = res.data.data;
        if (res.data.data?.listing?.third_party_type) {
          localStorage.setItem(`third_party_type_${propertyId.value}`, res.data.data.listing.third_party_type);
        }
        
        if (res.data.data?.listing?.r2bPropertyDetails) {
          nextTick(() => {
            setTimeout(() => {
              initializeR2BCalendars();
            }, 100);
          });
        }
      })
      .catch((err) => {
        if (toastRef.value) {
          toastRef.value.addToast(`${err.response?.data?.message || 'There is some issue while fetching the hotel details'}`, "error");
        }
      });
  }
  
  function backToMainView() {
    componentChangeStore.changeTheComponent("mainView");
    localStorage.removeItem("propertyDetailsPayload")
    localStorage.removeItem("selectedCheckin")
    localStorage.removeItem("selectedCheckout")
  }
  
  async function bookRoom(room) {
    selectedRoomForImages.value = null;
    selectedRoomForPrice.value = null;
    showDialog.value = false;
    await nextTick();
    const roomsData = searchStore.getRooms;
  
    let formattedOccupancy = [];
  
    if (Array.isArray(roomsData)) {
      formattedOccupancy = roomsData.map((roomItem) => {
        const adultsCount = roomItem.adults;
        const childrenAges = roomItem.ages.map((age) => age + 1).join(",");
        return childrenAges ? `${adultsCount}-${childrenAges}` : `${adultsCount}`;
      });
    }
  
    const bookingData = {
      rate_id: room.rates,
      room_id: room.name || room.room_id,
      book_hash: room.book_hash || "",
      meal: room.meal || "",
      listing_id: hotels.value?.listing?.id || "",
      property_id: hotels.value?.propertyId || "",
      checkin: checkinDate.value,
      checkout: checkoutDate.value,
      third_party_type: hotels.value?.listing?.third_party_type || "Ratehawk",
      occupancy: formattedOccupancy,
    };
    bookingStore.addValueToBookingRoom(bookingData);
    localStorage.setItem("bookingData", JSON.stringify(bookingData));
  
    const urlParams = new URLSearchParams(window.location.search);
    const tabId = urlParams.get("tabId");
    const currentTabId = tabId || localStorage.getItem("currentTabId") || "main_tab";
  
    localStorage.setItem(`componentLoad_${currentTabId}`, "bookingView");
    localStorage.setItem("componentLoad", "bookingView");
  
    const currentUrl = new URL(window.location.href);
  
    if (!currentUrl.searchParams.has('propertyId') && propertyId.value) {
      currentUrl.searchParams.set('propertyId', propertyId.value);
    }
  
    if (!currentUrl.searchParams.has('propertyName') && slugifiedPropertyName.value) {
      currentUrl.searchParams.set('propertyName', slugifiedPropertyName.value);
    }
  
    if (!currentUrl.searchParams.has('tabId') && currentTabId) {
      currentUrl.searchParams.set('tabId', currentTabId);
    }
  
    currentUrl.searchParams.set('view', 'bookingView');
    window.history.replaceState({}, '', currentUrl.toString());
  
    document.body.style.overflow = "auto";
    componentChangeStore.changeTheComponent("bookingView");
  }
  
  onUnmounted(() => {
    document.body.style.overflow = "auto";
    
    // Cleanup R2B inline calendars
    if (R2BCalendarCheckInDate) {
      R2BCalendarCheckInDate.destroy();
    }
    if (calendarCheckOutDate) {
      calendarCheckOutDate.destroy();
    }
    
    // Cleanup r2b calendars (primary booking calendars)
    if (r2bPickersCleanup) {
      r2bPickersCleanup();
    }
    if (r2bCheckinPicker) {
      try {
        r2bCheckinPicker.destroy();
      } catch (e) {
        // ignore
      }
    }
    if (r2bCheckoutPicker) {
      try {
        r2bCheckoutPicker.destroy();
      } catch (e) {
        // ignore
      }
    }
  });
    
    </script>

    <style scoped>
    /* Make the flatpickr calendar compact */
    :deep(.flatpickr-calendar) {
      width: 245px !important;
      font-size: 10px !important;
    }
  
    :deep(.flatpickr-months) {
      padding: 2px !important;
    }
  
    :deep(.flatpickr-current-month) {
      font-size: 13px !important;
      padding: 2px 0 !important;
    }
  
    :deep(.flatpickr-prev-month),
    :deep(.flatpickr-next-month) {
      padding: 4px !important;
    }
  
    :deep(.flatpickr-weekday) {
      font-size: 10px !important;
    }
  
    :deep(.flatpickr-day) {
      height: 28px !important;
      line-height: 28px !important;
      max-height: 28px !important;
      font-size: 10px !important;
    }
  
    :deep(.dayContainer) {
      width: 245px !important;
      min-width: 245px !important;
      max-width: 245px !important;
    }
  
    :deep(.flatpickr-days) {
      width: 245px !important;
    }
    </style>
  
    